import { render } from "./LoginLayout.vue?vue&type=template&id=65f44dfd&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=65f44dfd&scoped=true&lang=scss"

import exportComponent from "D:\\Work\\renny\\rotto-sale\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f44dfd"]])

export default __exports__